import BiddingItem from './bidding.item';

export default BiddingItem;
